export default __webpack_public_path__ + "static/media/led2_New.bef6c868.png";